import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useIsMobile } from '../../hooks/useIsMobile'
import './Tokenomics.css'

export const Tokenomics = () => {
    const { t } = useTranslation()
    const story = t('story', { returnObjects: true })
    const isMobile = useIsMobile()
    const [copied, setCopied] = useState(false)

    const handleCopy = () => {
        navigator.clipboard.writeText(story.contractAddress)
        setCopied(true)
        setTimeout(() => setCopied(false), 2000)
    }

    const cards = [
        [
            { label: story.tokenName, value: story.tokenNameValue },
            { label: story.tokenChain, value: story.tokenChainValue, badge: true },
        ],
        [
            { label: story.tokenSupply, value: story.tokenSupplyValue },
            { label: story.tokenCirculating, value: story.tokenCirculatingValue },
        ],
        [
            { label: story.tokenTax, value: story.tokenTaxValue },
            { label: story.tokenLiquidity, value: story.tokenLiquidityValue },
        ],
        [
            { label: story.tokenAvailable, value: story.tokenAvailableValue },
        ],
    ]

    return (
        <div className='page-container'>
            <h2 className='tokenomics-section-title fire-title'>{story.tokenomicsTitle}</h2>

            <div className='page-content-container'>
                {cards.map((group, index) => (
                    <div
                        key={index}
                        className={`page-item tokenomics-card ${!isMobile ? (index % 2 === 0 ? 'left' : 'right') : ''}`}>
                        <div className='page-content'>
                            <div className='tokenomics-stats-group'>
                                {group.map((stat) => (
                                    <div
                                        className='tokenomics-stat'
                                        key={stat.label}>
                                        <span className='tokenomics-label'>{stat.label}</span>
                                        <span className='tokenomics-value'>
                                            {stat.value}
                                            {stat.badge && <span className='ton-badge'>TON</span>}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                ))}

                <div className={`page-item ${!isMobile ? 'left' : ''}`}>
                    <div className='page-content'>
                        <div className='tokenomics-stat'>
                            <span className='tokenomics-label'>{story.contractTitle}</span>
                            <div className='contract-address-wrapper'>
                                <code className='contract-address'>{story.contractAddress}</code>
                                <button
                                    className='contract-copy-btn'
                                    onClick={handleCopy}>
                                    {copied ? story.contractCopied : '📋'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
